import { VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { Typography } from 'components/atoms';

type CreditSummaryItemProps = {
  label: string;
  value?: number | null;
  emptyValue?: ReactNode;
};

export const CreditSummaryItem = ({
  label,
  value,
  emptyValue = 0,
}: CreditSummaryItemProps) => (
  <VStack align="flex-start" spacing="4px">
    <Typography.Title fontSize="lg" lineHeight="1">
      {value === null || value === undefined
        ? emptyValue
        : Number(value).toLocaleString('en-US')}
    </Typography.Title>
    <Typography.Text>{label}</Typography.Text>
  </VStack>
);
